import React from 'react';
import { IUser } from '../../../../Interfaces/responseTypes';
import UserAvatar from '../../../Avatars/UserAvatar/userAvatar';
import useUserDrawerHooks from './userDrawer-hooks';
import CustomDialog from '../../../Dialog/customDialog';
import { LogoutIcon } from '../../../../Assets/Icons';
import styles from './userDrawer.module.scss';
import { t } from 'i18next';

interface IProps {
    user: IUser
}

const UserDrawer: React.FC<IProps> = ({ user }) => {
    const { userDrawerItems, dialogComponent, open, onClose, onOpenLogOutDialog } = useUserDrawerHooks();

    return (
        <>
            <div className={styles.container}>
                <div className={styles.avatarBox}>
                    <UserAvatar
                        user={user}
                    />
                </div>
                <div className={styles.itemBox}>
                    {
                        userDrawerItems.map((el, index) => {
                            return (
                                <div className={styles.item} key={index} onClick={el.onClick}>
                                    <img src={el.icon} alt='icon' />
                                    <p className={styles.itemTitle}>{el.title}</p>
                                </div>
                            )
                        })
                    }
                </div>
                <div className={styles.logOutBox} onClick={onOpenLogOutDialog}>
                    <img src={LogoutIcon} alt='icon' />
                    <p className={styles.logOutText}>{t('Buttons.Log_Out')}</p>
                </div>
            </div>
            <CustomDialog
                open={open}
                onClose={onClose}
                children={dialogComponent}
            />
        </>
    )
}

export default UserDrawer
